import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-TimeBubble",
  "use": "icon-TimeBubble-usage",
  "viewBox": "0 0 896.14 511.84",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 896.14 511.84\" id=\"icon-TimeBubble\"><defs></defs><g id=\"icon-TimeBubble_图层_2\" data-name=\"图层 2\"><g id=\"icon-TimeBubble_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"896.14\" height=\"384\" rx=\"192\" /><path class=\"cls-1\" d=\"M398.06,441.93a290.37,290.37,0,0,1,49.83,69.91,346.92,346.92,0,0,1,128-127.47h-256A290.59,290.59,0,0,1,398.06,441.93Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol